import createApp from '../createApp'
import Method from './Method.vue'

document.addEventListener('DOMContentLoaded', () => createApp(
  Method,
  ({ hooks, hook, saved_auth_params }) => ({ hooks, hook, saved_auth_params }),
), false)
